import { motion } from "framer-motion";
import React from "react";
import { Image } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import MidBox from "../../components/Boxes/MidBox";
import Button from "../../components/Button";
import { useAppTranslation } from "../../i18n/useAppTranslation";

type Props = {
  title: "Deposit" | "Withdraw";
  direction: "left" | "right";
  id?: string;
};

const DisabledTransactionCard = ({ title, direction, id }: Props) => {
  const { t } = useAppTranslation("profile");
  // title picks the card's look; what the player reads is its translation.
  const label = title === "Deposit" ? t("profile:depositCard.title") : t("profile:withdrawCard.title");
  return (
    <motion.div
      initial={isMobile ? undefined : { opacity: 0, x: direction === "left" ? -800 : 800 }}
      transition={{
        duration: 0.3,
        delay: direction === "left" ? 0.2 : 0.3,
      }}
      animate={{
        opacity: 1,
        x: 0,
      }}
      exit={{ opacity: 0, x: direction === "left" ? -800 : 800 }}
      className="col-12 col-md-6"
    >
      <MidBox modal id={id} title={label} className="text-center">
        <div className="mb-2">
          <Image
            style={title === "Deposit" ? { transform: "rotate(180deg)" } : undefined}
            className="img-fluid"
            src="/assets/images/icons/withdraw.png"
            alt={label}
          />
        </div>

        <div className="alert alert-danger mb-4" role="alert">
          <b>{t("profile:disabledCard.disabled", { title: label })}</b>
          <div className="fs-small mt-2">
            {t("profile:disabledCard.comingSoon")}
          </div>
        </div>

        <Button
          disabled
          variant={title === "Deposit" ? "wide-primary" : "wide"}
          style={{ width: "240px" }}
          className="mx-auto"
        >
          <Image
            width={30}
            height={30}
            className="img-fluid"
            src="/assets/images/logos/metamask-circle.png"
            alt="MetaMask"
          />
          <span className="text-light d-block"> {label}</span>
        </Button>
      </MidBox>
    </motion.div>
  );
};

export default DisabledTransactionCard;
